// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_a2-4";
export var collapsed = "_a2-1";
export var headerBar = "_a2-0";
export var leftHeaderContent = "_a2-3";
export var subjectContainer = "_a2-2";